import { useState, useEffect } from 'react';

const useNetworkStatus = () => {
  const [status, setStatus] = useState({
    downlink: 0,
    rtt: 0,
    effectiveType: 'unknown',
    health: 'Excellent',
    color: 'text-success'
  });

  const getHealthStatus = (conn) => {
    const { downlink, rtt } = conn;

    // Default to Excellent if no data (Chromium only provides real data)
    if (!downlink) return { health: 'Connected', color: 'text-success' };

    if (downlink > 2 && rtt < 300) {
      return { health: 'Good', color: 'text-success' };
    } else if (downlink > 0.5 && rtt < 600) {
      return { health: 'Fair', color: 'text-warning' };
    } else {
      return { health: 'Poor', color: 'text-danger' };
    }
  };

  useEffect(() => {
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    const updateStatus = () => {
      if (conn) {
        const { downlink, rtt, effectiveType } = conn;
        const { health, color } = getHealthStatus(conn);
        setStatus({ downlink, rtt, effectiveType, health, color });
      }
    };

    if (conn) {
      conn.addEventListener('change', updateStatus);
      updateStatus();
    }

    return () => {
      if (conn) {
        conn.removeEventListener('change', updateStatus);
      }
    };
  }, []);

  return status;
};

export default useNetworkStatus;
